import MicroModal from 'micromodal';

$(() => {
  var showModal = (id) => {
    MicroModal.show(id, {
      awaitCloseAnimation: true,
      disableScroll: true,
      disableFocus: true
    });
  };

  $(document).on('click', '[data-modal-path]', function (e) {
    var path = $(e.target).data('modal-path');
    $.get(path).done((html) => {
      var modalId = $(html).attr('id');
      $(`#${modalId}`).remove();
      $(document.body).append(html);
      showModal(modalId);
    });
  });

  $('.modal').filter("[data-auto-show='true']").each((_idx, el) => showModal($(el).attr('id')));
  $('[data-modal-trigger]').on('click', (e) => showModal($(e.target).attr('data-modal-trigger')));

  window.addEventListener('modal-close', (e) => MicroModal.close(e.detail));
  window.addEventListener('modal-show', (e) => showModal(e.detail));
});
